export const INIT_QRY_FUNCTION = 'INIT_QRY_FUNCTION';
export const SET_RECENT_QUERIES = 'SET_RECENT_QUERIES';
export const FILE_QRY_FUNCTION =  'FILE_QRY_FUNCTION';
export const SET_RECENT_QRY_CLICKED_OUTPUT = 'SET_RECENT_QRY_CLICKED_OUTPUT';
export const SET_QRY_INPUT_SEARCHED_OUTPUT = 'SET_QRY_INPUT_SEARCHED_OUTPUT';
export const RECONCILE_FUNCTION = 'RECONCILE_FUNCTION';